import axios from "axios"
import store from "@/store"

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  withCredentials: false,
  header: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
})

apiClient.interceptors.response.use(
  response => response,
  error => {
    const {
      response: { status },
    } = error
    if (status === 401) {
      if (store.getters.loggedIn) {
        store.dispatch("logout")
      }
    }
    throw error
  }
)

export default apiClient
